import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; // Import default styles

const FacebookStyleLoader = () => (
  <div
    style={{
      height: '100vh',
      padding: '10px',
      maxWidth: '600px',
      margin: '0 auto',
      overflowY: 'hidden',
    }}
  >
    <Skeleton height={200} />
    <div style={{ marginTop: '10px' }}>
      <Skeleton width="80%" height={15} />
      <Skeleton width="90%" height={15} />
      <Skeleton width="60%" height={15} />
    </div>
  </div>
);

export default FacebookStyleLoader;
